<template>
  <v-data-table
    density="compact"
    hide-default-footer
    :headers="getHeader()"
    :items="claims"
    :items-per-page="-1"
    :mobile-breakpoint="960"
  >
    <template #item.date="{ item }">
      {{ m(item.date, $t("commonStrings.dateDisplayFormat")) }}
    </template>
    <template #item.claimTypeId="{ item }">
      {{ $t(`enums.vehicleTypes.${item.claimTypeId}`) }}
    </template>
    <template
      v-if="canUseSalaryFraction"
      #item.usesSalaryFraction="{ item }"
    >
      <v-checkbox
        v-model="item.usesSalaryFraction"
        color="primary"
        :label="$t('commonStrings.salaryFractionLabel')"
        :disabled="true"
      />
    </template>
    <template #item.payingOrgs="{ item }">
      <paying-orgs-label :paying-orgs="item.payingOrgs" />
    </template>
    <template #item.passengers="{ item }">
      <passenger-tooltip
        :key="item.passengers.join(',')"
        :claim="item"
      />
    </template>
    <template #item.amount="{ item }">
      <amount-label :value="item.amount" />
    </template>
    <template #item.info="{ item }">
      <trip-rate-information-tooltip
        v-if="item.hasOwnProperty('amount')"
        :claim="item"
      />
    </template>
    <template #item.editAction="{ item }">
      <v-btn
        size="small"
        rounded
        class="primary-inverted-button my-2"
        @click="onEdit(item)"
      >
        {{
          $t("drivingPanelStrings.labels.editButton")
        }}
      </v-btn>
    </template>
    <template #item.removeAction="{ item }">
      <v-btn
        size="small"
        rounded
        class="accent-inverted-button my-2"
        @click="remove(item)"
      >
        {{
          $t("drivingPanelStrings.labels.removeButton")
        }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import PayingOrgsLabel from "@/views/applications/components/PayingOrgsLabel";
import PassengerTooltip from "@/views/applications/components/TripPassengersWithTooltip";
import TripRateInformationTooltip from "./TripRateInformationTooltip";
import AmountLabel from "@/views/common/components/AmountLabel";
import { m } from '@/plugins/moment';

export default {
  name: "TripsTable",
  components: {
    PayingOrgsLabel,
    PassengerTooltip,
    TripRateInformationTooltip,
    AmountLabel
  },
  props: {
    claims: {
      default: () => [],
      type: Array
    },
    remove: Function,
    canUseSalaryFraction: {
      required: true
    }
  },
  setup() {
    return { m };
  },
  computed: {
  },
  methods: {
    getHeader() {
      const headers = [
        {
          text: this.$t("drivingPanelStrings.tableHeaders.date"),
          value: "date",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.vehicleType"),
          value: "claimTypeId",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.payingOrgs"),
          value: "payingOrgs",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.from"),
          value: "from",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.to"),
          value: "to",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.tripLength"),
          value: "kilometers",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.passengers"),
          value: "passengers",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("drivingPanelStrings.tableHeaders.amount"),
          value: "amount",
          sortable: false,
          filterable: false
        },
        {
          value: "info",
          sortable: false,
          filterable: false
        },
        {
          value: "editAction",
          sortable: false,
          filterable: false
        },
        {
          value: "removeAction",
          sortable: false,
          filterable: false
        }
      ];

      if (this.canUseSalaryFraction) {
        headers.splice(2, 0, {
          text: this.$t("commonStrings.salaryFraction"),
          value: "usesSalaryFraction",
          sortable: false,
          filterable: false
        });
      }

      return headers;
    },
    onEdit(claim) {
      const index = this.claims.indexOf(claim);
      this.$emit("edit-clicked", { claim, index });
    }
  }
};
</script>